<mat-card class="cardWithShadow">
    <mat-card-content>
        <mat-card-title class="header">
            Documentos
            <button type="button" (click)="createNewDocumentType()" mat-stroked-button color="primary">Añadir Documento</button>
        </mat-card-title>
        <div class="main-container">
            <div *ngIf="(documentTypes$ | async) as documentTypes; else spinnersection">
                <app-document-types-table 
                [documentTypes]="documentTypes"
                (documentTypeToUpdate)="updateDocumentType($event)">
                </app-document-types-table>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #spinnersection>
    <section style="display:flex; justify-content: center;">
        <mat-spinner diameter="60"></mat-spinner>
    </section>
</ng-template>